import { useEffect, useState } from "react";
import { useParticipant, usePubSub } from "@videosdk.live/react-sdk";
import styles from "../PD/pd.module.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import Cookies from "js-cookie";
import { url } from "../../../../../../../../../App";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import ImagePreviewModal from "./ImagePreviewModal";

export default function ParticipantView(props) {
  // console.log(props)
  //eslint-disable-next-line
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const loanID = sessionStorage.getItem("LoanID");
  const { borrowerData } = useBorrowerContext();
  const borrower = borrowerData.borrower;
  // console.log(borrower)
  const [userName, setUserName] = useState("");
  const [userConsent, setUserConsent] = useState("");
  const [userLatitude, setUserLatitude] = useState("");
  const [userLongitude, setUserLongitude] = useState("");
  const [localBitrate, setLocalBitrate] = useState(null);
  const [remoteBitrate, setRemoteBitrate] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const { micRef, videoRef, meetingId } = props;
  console.log(isModalOpen);
  const {
    webcamStream,
    micStream,
    webcamOn,
    micOn,
    isLocal,
    getAudioStats,
    getVideoStats,
    setQuality,
    setViewPort,
  } = useParticipant(props.participantId);
//   const isCapturingRef = useRef(false);
  const [prevWebcamOn, setPrevWebcamOn] = useState(webcamOn);
  const [prevMicOn, setPrevMicOn] = useState(micOn);
  const [seconds, setSeconds] = useState(0);
//   const { publish: publishCapture } = usePubSub("IMAGE_CAPTURE");
  const { publish: publishSnapshot } = usePubSub("SNAPSHOT_ADDED");
  const { publish: publishBitrate, messages } = usePubSub("bitrate");

  usePubSub("IMAGE_CAPTURE", {
    onMessageReceived: (message) => {
      const { type } = message.payload || {};

      if (type === "CAPTURE_IMAGE") {
        handleImageCapture();
      }
    },
  });

//   function sendRequest() {
//     publishCapture(
//       { type: "CAPTURE_IMAGE" },
//       {
//         persist: false,
//         sendOnly: [props.participantId],
//       },
//     );
//   }

  usePubSub("SNAPSHOT_ADDED", {
    onMessageReceived: (message) => {
      console.log("SNAPSHOT EVENT:", message);

      const image = message?.message?.image;

      if (!image) return;

      //   setSnapshots((prev) => [image, ...prev]);
    },
  });

  usePubSub("user_consent", {
    onMessageReceived: (message) => {
      const { consent } = message.payload;
      if (consent === "true" || consent === true) {
        setUserConsent("true");
      } else {
        setUserConsent("false");
      }
    },
  });

  usePubSub("user_address", {
    onMessageReceived: (message) => {
      const { lat, lng } = message.payload;
      setUserLatitude(lat);
      setUserLongitude(lng);
    },
  });

  useEffect(() => {
    if (!isLocal) {
      setQuality("high");
      // setViewPort(1280, 720);
      setViewPort(1920, 1080);
    }
  }, [isLocal, setQuality, setViewPort]);

  useEffect(() => {
    if (webcamOn && webcamStream && videoRef?.current) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      videoRef.current.srcObject = mediaStream;
      videoRef.current
        .play()
        .catch((err) => console.error("Video play failed:", err));
    } else if (videoRef?.current) {
      videoRef.current.srcObject = null;
    }
  }, [webcamStream, webcamOn, videoRef]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
        micRef.current.srcObject = mediaStream;

        micRef.current
          .play()
          .catch((error) =>
            console.error("micRef.current.play() failed", error),
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn, micRef]);

  useEffect(() => {
    if (prevWebcamOn !== webcamOn) {
      toast(`Webcam is ${webcamOn ? "ON" : "OFF"}`, {
        type: webcamOn ? "success" : "error",
      });
      setPrevWebcamOn(webcamOn);
    }
  }, [webcamOn, prevWebcamOn]);

  useEffect(() => {
    if (prevMicOn !== micOn) {
      toast(`Mic is ${micOn ? "ON" : "OFF"}`, {
        type: micOn ? "success" : "error",
      });
      setPrevMicOn(micOn);
    }
  }, [micOn, prevMicOn]);

  useEffect(() => {
    axios
      .post(url + "/user/getsingle", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        useremail: Cookies.get("Email"),
      })
      .then((res) => {
        // console.log(res);
        setUserName(res.data[0]?.staff_name);
      })
      .catch((err) => {
        console.log(err);
        // toast.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (isLocal) {
      const interval = setInterval(async () => {
        try {
          const [videoStats, audioStats] = await Promise.all([
            getVideoStats(),
            getAudioStats(),
          ]);
          const totalVideoBitrate =
            videoStats?.reduce((acc, s) => acc + (s.bitrate || 0), 0) || 0;
          const totalAudioBitrate =
            audioStats?.reduce((acc, s) => acc + (s.bitrate || 0), 0) || 0;
          const total = (
            (totalVideoBitrate + totalAudioBitrate) /
            1000
          ).toFixed(1);
          setLocalBitrate(total);

          publishBitrate(
            { participantId: props.participantId, bitrate: total },
            { persist: false },
          );
        } catch (error) {
          console.error("Bitrate fetch error:", error);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [
    isLocal,
    getAudioStats,
    getVideoStats,
    publishBitrate,
    props.participantId,
  ]);

  useEffect(() => {
    if (!isLocal && messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      if (
        lastMessage?.message?.participantId === props.participantId &&
        lastMessage?.message?.bitrate
      ) {
        setRemoteBitrate(lastMessage.message.bitrate);
      }
    }
  }, [isLocal, messages, props.participantId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (totalSeconds) => {
    const mins = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const getFormattedDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getFormattedTime = () => {
    return new Date().toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  };
  // useEffect(() => {
  //   navigator.mediaDevices.getUserMedia({ video: true, audio: true })
  //     .then((stream) => {
  //       videoRef.current.srcObject = stream;
  //     })
  //     .catch(() => {
  //       alert("Camera or microphone permission denied");
  //     });
  // }, []);

  const handleImageCapture = async () => {
    try {
      const video = videoRef.current;

      if (!video) throw new Error("Video not found");

      const rect = video.getBoundingClientRect();

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = rect.width;
      canvas.height = rect.height;

      ctx.drawImage(
        video,
        0,
        0,
        video.videoWidth,
        video.videoHeight,
        0,
        0,
        rect.width,
        rect.height,
      );

      const base64Data = canvas.toDataURL("image/jpeg", 0.95).split(",")[1];

      setPreviewImage(base64Data);
      setModalOpen(true);
    } catch (error) {
      console.error("Image capture failed:", error);
      toast.error("Camera not ready. Please try again.");
    }
  };

  const handleApprove = async () => {
    try {
      const imageToUpload = previewImage;

      setModalOpen(false);
      setPreviewImage(null);

      setSnapshots((prev) => [imageToUpload, ...prev]);

      await axios.post(`${url}/videosdk/upload`, {
        token,
        email,
        borrower_Id: borrower.borrower_uniqueno,
        base64Data: imageToUpload,
        loan_Id: loanID,
      });

      toast.success("Image uploaded successfully!");

      publishSnapshot(
        { image: imageToUpload, type: "SNAPSHOT" },
        { persist: false },
      );
    } catch (err) {
      toast.error("Upload failed.");
      console.error(err);
    }
  };

  const handleRetake = async () => {
    setPreviewImage(null);
    setModalOpen(false);
  };

  const handleClose = async () => {
    setPreviewImage(null);
    setModalOpen(false);
  };

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.topSection}>
        {isLocal && (
          <div className={styles.agentVideoContainer}>
            <div className={styles.participantHeader}>
              <span className={styles.participantName}>{userName}</span>
              <p style={{ color: "green", fontWeight: "bold" }}>
                Agent: {localBitrate || "..."} Mbps
              </p>
              <div className={styles.iconContainer}>
                {webcamOn ? (
                  <VideocamIcon className={styles.iconOn} />
                ) : (
                  <VideocamOffIcon className={styles.iconOff} />
                )}
                {micOn ? (
                  <MicIcon className={styles.iconOn} />
                ) : (
                  <MicOffIcon className={styles.iconOff} />
                )}
              </div>
            </div>

            <audio ref={micRef} autoPlay playsInline muted={isLocal} />
            {webcamOn && (
              <div className={styles.agentSdk}>
                <video
                  ref={videoRef}
                  autoPlay
                  muted={true}
                  playsInline
                  controls={true}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                  }}
                />
              </div>
            )}
          </div>
        )}

        {isLocal && (
          <div className={styles.detailsBox}>
            <p>
              <strong>Name:</strong>
              {`${borrower.borrower_firstname} ${borrower.borrower_middlename ? borrower.borrower_middlename + " " : ""}${borrower.borrower_lastname}`}
            </p>
            <p>
              <strong>Mobile:</strong> {borrower.borrower_mobile}
            </p>
            <p>
              <strong>Address:</strong> {borrower.borrower_permanent_address}
            </p>
            {userLatitude && userLongitude && (
              <p>
                <strong>Lat-Long:</strong> {`${userLatitude}, ${userLongitude}`}
              </p>
            )}
            {userConsent && (
              <p>
                <strong>Customer Consent:</strong> {userConsent}
              </p>
            )}
            <p>
              <strong>Calling Time:</strong> {getFormattedTime()}
            </p>
            <p>
              <strong>Date:</strong> {getFormattedDate()}
            </p>
            <p>
              <strong>Meeting ID:</strong> {meetingId}
            </p>
            <p>
              <strong>Session Duration:</strong>
              <div className={styles.timerBox}>
                <span className={styles.redDot}></span>
                <span>{formatTime(seconds)}</span>
              </div>
            </p>
          </div>
        )}
      </div>

      {!isLocal && (
        <div className={styles.bottomSection}>
          <div className={styles.customerVideoContainer}>
            <div className={styles.participantHeader}>
              <span className={styles.participantName}>
                {`${borrower.borrower_firstname} ${borrower.borrower_middlename ? borrower.borrower_middlename + " " : ""}${borrower.borrower_lastname}`}
              </span>
              <p style={{ color: "blue", fontWeight: "bold" }}>
                Customer: {remoteBitrate || "..."} Mbps
              </p>
              <div className={styles.iconContainer}>
                {webcamOn ? (
                  <VideocamIcon className={styles.iconOn} />
                ) : (
                  <VideocamOffIcon className={styles.iconOff} />
                )}
                {micOn ? (
                  <MicIcon className={styles.iconOn} />
                ) : (
                  <MicOffIcon className={styles.iconOff} />
                )}
              </div>
            </div>

            <audio ref={micRef} autoPlay playsInline muted={isLocal} />
            {webcamOn && (
              <div className={styles.customerSdk}>
                <video
                  ref={videoRef}
                  autoPlay
                  muted={true}
                  playsInline
                  controls={true}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}

            <Tooltip title="Capture Image">
              <button
                className={styles.captureButton}
                onClick={async () => {
                  await handleImageCapture();
                  //   if (!isLocal) {
                  //     sendRequest();
                  //   }
                }}
              >
                Capture
              </button>
            </Tooltip>
          </div>

          <ImagePreviewModal
            imageSrc={previewImage}
            onApprove={handleApprove}
            onRetake={handleRetake}
            onClose={handleClose}
            open={isModalOpen}
          />

          <div className={styles.snapshotsBox}>
            <div className={styles.snapshotsGrid}>
              {snapshots.length > 0 &&
                snapshots.map((img, index) => (
                  <img
                    key={index}
                    src={`data:image/jpeg;base64,${img}`}
                    alt={`snapshot-${index}`}
                    className={styles.snapshotImage}
                  />
                ))}
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
}
